import { handleResponse, Headers } from '../_helpers';

export const EventService = {
  loadEventTypes,
  saveNewEvent,
  getChronicleEvents,
  createCopy,
  deleteEvent,
  updateEvent,
  deleteMultiple,
  moveMultiple,
};

function loadEventTypes() {
  const request = {
    method: 'GET',
    headers: Headers.set({ auth: false }),
  };

  return fetch(`${process.env.API_URL}/api/v1/event/types`, request)
    .then(handleResponse)
    .then((eventTypes) => eventTypes);
}

function saveNewEvent(eventData) {
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify(eventData),
  };

  return fetch(`${process.env.API_URL}/api/v1/event/new`, request)
    .then(handleResponse)
    .then((eventItem) => eventItem);
}

function getChronicleEvents(chronicleID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/event/chronicle/${chronicleID}`,
    request
  )
    .then(handleResponse)
    .then((eventItems) => eventItems);
}

function createCopy(id) {
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify({ eventID: id }),
  };

  return fetch(`${process.env.API_URL}/api/v1/event/copy`, request);
}

function updateEvent(id, params) {
  const request = {
    method: 'PUT',
    headers: Headers.set(),
    body: JSON.stringify(params),
  };
  return fetch(`${process.env.API_URL}/api/v1/event/${id}`, request)
    .then(handleResponse)
    .then((updatedEvent) => {
      return updatedEvent;
    });
}

function deleteEvent(id) {
  const request = {
    method: 'DELETE',
    headers: Headers.set(),
  };
  return fetch(`${process.env.API_URL}/api/v1/event/${id}`, request)
    .then(handleResponse)
    .then(() => {
      return id;
    });
}

function deleteMultiple(eventIDs) {
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify({ eventIDs }),
  };

  return fetch(`${process.env.API_URL}/api/v1/event/delete`, request)
    .then(handleResponse)
    .then((events) => {
      return events;
    });
}

function moveMultiple(timelineID, eventIDs) {
  const request = {
    method: 'PATCH',
    headers: Headers.set(),
    body: JSON.stringify({ timelineID, eventIDs }),
  };

  return fetch(`${process.env.API_URL}/api/v1/event/move`, request)
    .then(handleResponse)
    .then((events) => events);
}
